import useFilters from '../../../hook/useFilters'
import {parsePurchaserReportData} from '../utils'
import useApi from '../../../services/useApi'

const useGetPurchaserReport = () => {
  const Api = useApi()

  const initialFilters = {
    sort_by: 'total/-1',
  }

  const {filters, onSearch, onSortingChange} = useFilters(initialFilters, {
    sortType: 'number',
  })

  const {data: response, isFetching} = Api.useGetQuery('/products/inquiries/purchaser-report', {
    filters: filters,
  })

  return {
    purchaserData: parsePurchaserReportData(response?.data || []),
    isLoading: isFetching,
    filters,
    searchValue: filters.search,
    onSearch,
    onSortingChange,
  }
}

export default useGetPurchaserReport
